import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'particle-task-title',
  templateUrl: './task-title.component.html',
  styleUrls: ['./task-title.component.scss']
})
export class TaskTitleComponent implements OnInit, IDialogView {
  data: DialogModel;
  constructor(protected route: Router) { }
  public navigate() {
    this.data['dialogRef'].close({
      action: 'Redirect',
      url: this.data['parentTaskUrl'],
      board: this.data['board'],
      card: this.data['parentCard']
    });
  }
  ngOnInit() {
  }
  onOkClicked (): boolean {
    return true;
  }
}
